import CustomerService from '_services/rest/modules/customer';
import { CONTACT, ADDRESS } from './components/CustomerModel';

export default {
  state: {
    customer: null,
    customerList: null,
  },
  mutations: {
    setCustomerList(state, response) {
      state.customerList = response;
    },
    setCustomer(state, response) {
      state.customer = response;
      state.type = response.type || 'individual';
    },
    setCustomerAddress(state, addresses) {
      if (addresses.length > 0) {
        addresses.forEach(address => {
          const [street, number] = address.address.split(', ');
          address.street = street;
          address.number = number;
        });
        state.customer.addresses = addresses;
        return;
      }
      state.customer.addresses = [{ ...ADDRESS }];
    },
    setCustomerContact(state, contacts) {
      if (contacts.length > 0) {
        state.customer.contacts = contacts;
        return;
      }
      state.customer.contacts = [{ ...CONTACT }];
    },
  },
  actions: {
    getCustomerList({ commit }, params) {
      return CustomerService.getList(params)
        .then(response => {
          commit('setCustomerList', response);
        });
    },
    getCustomer({ commit }, params) {
      return CustomerService.getCustomerById(params)
        .then(response => {
          const customer = response[0];
          commit('setCustomer', customer);
          commit('setCustomerAddress', customer.addresses);
          commit('setCustomerContact', customer.contacts);
        });
    },
    getCustomerAddress({ commit }, addresses) {
      commit('setCustomerAddress', addresses);
    },
  },
};
